import { render } from "./MedicalDashboard.vue?vue&type=template&id=3d06fd48&scoped=true"
import script from "./MedicalDashboard.vue?vue&type=script&lang=js"
export * from "./MedicalDashboard.vue?vue&type=script&lang=js"

import "./MedicalDashboard.vue?vue&type=style&index=0&id=3d06fd48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d06fd48"]])

export default __exports__